import { createContext } from 'react';

const useClientCallOutDashboard = createContext();
export default useClientCallOutDashboard;
